<app-page
  [flush]="true"
  pageTitle="Ponuda paketa"
  backLabel="Nazad"
  (backClicked)="goBack()"
>
  @if (loading()) {
    <div class="mt-5 flex justify-content-center">
      <i class="pi pi-spin pi-spinner" style="font-size: 2rem; color: #7E838F;"></i>
    </div>
  } @else if (packages().length === 0) {
    <div class="mt-5 empty-state flex flex-column align-items-center justify-content-center">
      <app-cube-01 stroke="#7E838F"></app-cube-01>
      <p class="mt-3 text-md-regular text-gray-500">Trenutno nema dostupnih paketa.</p>
    </div>
  } @else {

    <!-- Package cards -->
    <div class="mt-5 packages-grid">
      @for (card of cards(); track card.pkg.id) {
        <app-package-card
          [name]="card.name"
          [price]="card.pkg.price"
          [hours]="card.pkg.hours"
          [pricePerHour]="card.pkg.pricePerHour"
          [savings]="card.savings"
          [isPopular]="card.isPopular"
          [sections]="card.sections"
          [isBusy]="buyingPackageId() === card.pkg.id"
          (orderClicked)="openBuyDialog(card.pkg)"
        ></app-package-card>
      }
    </div>

    <!-- How it works -->
    <div class="how-it-works mt-card">
      <button class="hiw-toggle" (click)="isHowItWorksExpanded.set(!isHowItWorksExpanded())">
        <span class="text-sm-semibold text-gray-600">Kako funkcioniše kupovina</span>
        <app-chevron-right class="hiw-chevron" [direction]="isHowItWorksExpanded() ? 'up' : 'down'" stroke="#ADB0B8" width="7px" height="12px"></app-chevron-right>
      </button>

      @if (isHowItWorksExpanded()) {
        <div class="hiw-steps mt-4">

          <!-- Step 1 -->
          <div class="hiw-step">
            <div class="hiw-step-icon">
              <app-cube-01 stroke="#414651" width="20px" height="20px"></app-cube-01>
              <span class="hiw-step-num">1</span>
            </div>
            <div class="hiw-step-body">
              <div class="text-sm-semibold text-gray-900">Izaberite paket</div>
              <div class="text-sm-regular text-gray-500 mt-1">Pokrenite kupovinu odabranog paketa</div>
            </div>
          </div>

          <!-- Arrow -->
          <div class="hiw-arrow">
            <svg width="67" height="64" viewBox="0 0 67 64" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M1.97823 35.531C9.14649 31.8281 17.0343 29.527 25.0795 28.747C33.1831 27.9514 41.4285 28.6185 49.2594 30.7724C53.6458 31.9733 57.9082 33.6452 61.893 35.7978C63.098 36.4442 64.1657 34.5948 62.9607 33.9484C55.5246 30.0004 47.3452 27.5959 38.9633 26.6527C30.6553 25.7522 22.1392 26.4083 14.0508 28.5443C9.50003 29.7637 5.1113 31.4711 0.905981 33.6297C-0.283772 34.3237 0.772844 36.1667 1.97823 35.531Z" fill="#FDB022"/>
              <path d="M53.1596 21.5354C58.1171 25.3346 61.9928 30.5806 64.1651 36.4706C64.612 36.0382 65.022 35.5845 65.4689 35.152C60.1917 34.1273 54.7735 33.8595 49.4574 34.4397C48.8797 34.5007 48.3958 34.9118 48.3984 35.5051C48.3854 36.0401 48.8861 36.6251 49.4638 36.5641C54.6049 36.0307 59.8168 36.2288 64.9247 37.2051C65.6446 37.3248 66.5427 36.709 66.2285 35.8865C63.8202 29.4657 59.66 23.8582 54.1904 19.6646C53.7522 19.313 52.9881 19.6116 52.7318 20.0554C52.4485 20.6316 52.6845 21.1624 53.1596 21.5354Z" fill="#FDB022"/>
            </svg>
          </div>

          <!-- Step 2 -->
          <div class="hiw-step">
            <div class="hiw-step-icon">
              <app-file-06 stroke="#414651" width="20px" height="20px"></app-file-06>
              <span class="hiw-step-num">2</span>
            </div>
            <div class="hiw-step-body">
              <div class="text-sm-semibold text-gray-900">Primite fakturu</div>
              <div class="text-sm-regular text-gray-500 mt-1">Faktura stiže na vašu email adresu</div>
            </div>
          </div>

          <!-- Arrow -->
          <div class="hiw-arrow">
            <svg width="67" height="64" viewBox="0 0 67 64" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M1.97823 28.469C9.14649 32.1719 17.0343 34.473 25.0795 35.253C33.1831 36.0486 41.4285 35.3815 49.2594 33.2276C53.6458 32.0267 57.9082 30.3548 61.893 28.2022C63.098 27.5558 64.1657 29.4052 62.9607 30.0516C55.5246 33.9996 47.3452 36.4041 38.9633 37.3473C30.6553 38.2478 22.1392 37.5917 14.0508 35.4557C9.50003 34.2363 5.1113 32.5289 0.905981 30.3703C-0.283772 29.6763 0.772844 27.8333 1.97823 28.469Z" fill="#FDB022"/>
              <path d="M53.1596 42.4646C58.1171 38.6654 61.9928 33.4194 64.1651 27.5294C64.612 27.9618 65.022 28.4155 65.4689 28.848C60.1917 29.8727 54.7735 30.1405 49.4574 29.5603C48.8797 29.4993 48.3958 29.0882 48.3984 28.4949C48.3854 27.9599 48.8861 27.3749 49.4638 27.4359C54.6049 27.9693 59.8168 27.7712 64.9247 26.7949C65.6446 26.6752 66.5427 27.291 66.2285 28.1135C63.8202 34.5343 59.66 40.1418 54.1904 44.3354C53.7522 44.687 52.9881 44.3884 52.7318 43.9446C52.4485 43.3684 52.6845 42.8376 53.1596 42.4646Z" fill="#FDB022"/>
            </svg>
          </div>

          <!-- Step 3 -->
          <div class="hiw-step">
            <div class="hiw-step-icon">
              <app-credit-card-02 stroke="#414651" width="20px" height="20px"></app-credit-card-02>
              <span class="hiw-step-num">3</span>
            </div>
            <div class="hiw-step-body">
              <div class="text-sm-semibold text-gray-900">Izvršite uplatu</div>
              <div class="text-sm-regular text-gray-500 mt-1">Uplatu izvršite prema instrukcijama</div>
            </div>
          </div>

          <!-- Arrow -->
          <div class="hiw-arrow">
            <svg width="67" height="64" viewBox="0 0 67 64" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M1.97823 35.531C9.14649 31.8281 17.0343 29.527 25.0795 28.747C33.1831 27.9514 41.4285 28.6185 49.2594 30.7724C53.6458 31.9733 57.9082 33.6452 61.893 35.7978C63.098 36.4442 64.1657 34.5948 62.9607 33.9484C55.5246 30.0004 47.3452 27.5959 38.9633 26.6527C30.6553 25.7522 22.1392 26.4083 14.0508 28.5443C9.50003 29.7637 5.1113 31.4711 0.905981 33.6297C-0.283772 34.3237 0.772844 36.1667 1.97823 35.531Z" fill="#FDB022"/>
              <path d="M53.1596 21.5354C58.1171 25.3346 61.9928 30.5806 64.1651 36.4706C64.612 36.0382 65.022 35.5845 65.4689 35.152C60.1917 34.1273 54.7735 33.8595 49.4574 34.4397C48.8797 34.5007 48.3958 34.9118 48.3984 35.5051C48.3854 36.0401 48.8861 36.6251 49.4638 36.5641C54.6049 36.0307 59.8168 36.2288 64.9247 37.2051C65.6446 37.3248 66.5427 36.709 66.2285 35.8865C63.8202 29.4657 59.66 23.8582 54.1904 19.6646C53.7522 19.313 52.9881 19.6116 52.7318 20.0554C52.4485 20.6316 52.6845 21.1624 53.1596 21.5354Z" fill="#FDB022"/>
            </svg>
          </div>

          <!-- Step 4 -->
          <div class="hiw-step">
            <div class="hiw-step-icon">
              <app-stars-02 stroke="#414651" width="20px" height="20px"></app-stars-02>
              <span class="hiw-step-num">4</span>
            </div>
            <div class="hiw-step-body">
              <div class="text-sm-semibold text-gray-900">Započnite sa radom</div>
              <div class="text-sm-regular text-gray-500 mt-1">Paket se aktivira nakon potvrde uplate</div>
            </div>
          </div>

        </div>
      }
    </div>

  }
</app-page>

@if (selectedPkg()) {
  <app-buy-package-dialog
    [(isVisible)]="dialogVisible"
    [pkg]="selectedPkg()!"
    (confirmed)="buy(selectedPkg()!)"
  ></app-buy-package-dialog>
}
